import { motion } from "framer-motion";
import powerQuoteBg from "@/assets/power-quote-bg.png";
const PowerQuote = () => {
  return <section className="py-24 md:py-32 bg-black relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={powerQuoteBg} alt="" className="w-full h-full object-cover opacity-70" />
      </div>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/70" />
      
      <div className="container px-4 relative z-10">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center">
          <p className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            "Si tu marca no toma su lugar,{" "}
            <span className="text-muted-foreground">alguien más lo va a hacer.</span>{" "}
            Activá tu reputación."
          </p>
          
          <div className="mt-8 flex items-center justify-center gap-3">
            <div className="h-px w-12 bg-primary/50" />
            <span className="text-sm font-semibold tracking-widest uppercase text-muted-foreground">
              CORESSEN
            </span>
            <div className="h-px w-12 bg-primary/50" />
          </div>
        </motion.div>
      </div>
    </section>;
};
export default PowerQuote;